import { ReactNode } from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { ChevronLeftSvg, XSvg } from "@components/index";

export const DrawerHeader = ({
  onClose,
  title,
  rightContent,
  className,
  classNameCloseButton,
}: {
  title: ReactNode;
  rightContent?: ReactNode;
  className?: string;
  classNameCloseButton?: string;
  onClose: () => void;
}) => (
  <div
    className={clsx(
      "flex h-[50px] items-center justify-between border-b border-b-black-16 px-4 md:h-auto md:border-none md:px-14 md:pt-14",
      className,
    )}
  >
    <button type="button" className="text-black-54 md:hidden" onClick={onClose}>
      <ChevronLeftSvg />
    </button>
    <div className="relative">
      <button
        type="button"
        className={twMerge(
          clsx(
            "absolute -left-[74px] top-2 hidden h-8 w-8 items-center justify-center rounded-lg border border-black-8 bg-white-100 text-black-54 md:flex",
            classNameCloseButton,
          ),
        )}
        onClick={onClose}
      >
        <XSvg />
      </button>
      {title}
    </div>
    {rightContent ? rightContent : <div className="block md:hidden" />}
  </div>
);
